/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class EventEntity extends Entity {
  attachmentKey: string | null = null;
  attachmentName: string | null = null;
  bullhornNoteId: string | null = null;
  candidateId: string | null = null;
  createdAt: string | null = null;
  description: string | null = null;
  emailAddresses: string[] | null = null;
  id: string = '';
  integrationId: string | null = null;
  lastAuthoredBy: string | null = null;
  lastUpdatedBy: string | null = null;
  opportunityId: string | null = null;
  purpose: string | null = null;
  salesforceEventId: string | null = null;
  scheduledDate: string | null = null;
  type: string | null = null;
  updatedAt: string | null = null;
  static override key = 'Event';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Event' in input
    ) {
      const { Event: wrapped, ...rest } = input as {
        Event: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}